import calculateMinutesDuration from 'clientState/calculateMinutesDuration';
import { TechnicalStopFragment } from 'generated/graphql';

export default function technicalStopoverResolver(
  technicalStop: TechnicalStopFragment
) {
  const duration = calculateMinutesDuration(
    technicalStop.departureDate,
    technicalStop.arrivalDate
  );
  return {
    ...technicalStop,
    duration,
  };
}
